export default function getValueKey(_ref) {
  var normalized = _ref.normalized,
      cumulative = _ref.cumulative;
  if (normalized && cumulative) return 'cumulativeDensity';
  if (cumulative) return 'cumulative';
  if (normalized) return 'density';
  return 'count';
}